import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import Layout from '../components/Layout';

const ResidentMessages = () => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState({ subject: '', content: '' });
  const [showCompose, setShowCompose] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkUser();
  }, []);

  useEffect(() => {
    if (user) {
      const subscription = supabase
        .channel('messages')
        .on('postgres_changes', {
          event: '*',
          schema: 'public',
          table: 'messages',
          filter: `recipient_id=eq.${user.id}`
        }, () => {
          fetchMessages(user.id);
        })
        .subscribe();

      return () => {
        subscription.unsubscribe();
      };
    }
  }, [user]);

  const checkUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      setUser(user);
      fetchMessages(user.id);
    }
  };

  const fetchMessages = async (userId) => {
    try {
      const { data } = await supabase
        .from('messages')
        .select('*')
        .eq('recipient_id', userId)
        .order('created_at', { ascending: false });
      setMessages(data || []);
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    try {
      await supabase.from('messages').insert({
        sender_id: user.id,
        recipient_id: 'admin-user-id',
        subject: newMessage.subject,
        content: newMessage.content,
        channel: 'portal'
      });
      setNewMessage({ subject: '', content: '' });
      setShowCompose(false);
      fetchMessages(user.id);
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  const markAsRead = async (messageId) => {
    try {
      await supabase
        .from('messages')
        .update({ status: 'read' })
        .eq('id', messageId);
      fetchMessages(user.id);
    } catch (error) {
      console.error('Error marking message as read:', error);
    }
  };

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <h2>Messages</h2>
            {messages.filter(m => m.status === 'unread').length > 0 && (
              <span style={{
                padding: '4px 8px',
                background: '#dc3545',
                color: 'white',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>
                {messages.filter(m => m.status === 'unread').length} new
              </span>
            )}
          </div>
          <button 
            className="btn btn-primary"
            onClick={() => setShowCompose(true)}
          >
            New Message
          </button>
        </div>

        {showCompose && (
          <div style={{ marginBottom: '30px', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
            <h4>Send Message to Management</h4>
            <form onSubmit={sendMessage}>
              <div className="form-group">
                <label>Subject</label>
                <input 
                  type="text"
                  value={newMessage.subject}
                  onChange={(e) => setNewMessage({...newMessage, subject: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  value={newMessage.content}
                  onChange={(e) => setNewMessage({...newMessage, content: e.target.value})}
                  rows="4"
                  style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '4px' }}
                  required
                />
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" className="btn btn-primary">Send</button>
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={() => setShowCompose(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '20px' }}>
          <h3>Your Messages</h3>
          <div style={{ display: 'grid', gap: '15px', marginTop: '20px' }}>
            {messages.map(message => (
              <div key={message.id} style={{ 
                padding: '15px', 
                background: message.status === 'unread' ? '#f0f8ff' : '#f8f9fa', 
                borderRadius: '6px',
                border: message.status === 'unread' ? '1px solid #007bff' : '1px solid #eee'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                  <div>
                    <h4 style={{ margin: 0 }}>{message.subject}</h4>
                    <p style={{ margin: '10px 0', color: '#333' }}>{message.content}</p>
                    <p style={{ fontSize: '12px', color: '#666', margin: 0 }}>
                      {new Date(message.created_at).toLocaleDateString()} at {new Date(message.created_at).toLocaleTimeString()}
                    </p>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {message.status === 'unread' && (
                      <span style={{ 
                        padding: '2px 8px', 
                        background: '#007bff', 
                        color: 'white', 
                        borderRadius: '12px',
                        fontSize: '12px'
                      }}>
                        New
                      </span>
                    )}
                    {message.status === 'unread' && (
                      <button
                        onClick={() => markAsRead(message.id)}
                        style={{
                          padding: '2px 8px',
                          background: '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          fontSize: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        Mark Read
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
            {messages.length === 0 && (
              <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
                No messages yet. Send a message to property management above.
              </p>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ResidentMessages;